import axios from "axios";
import api, { apiData } from "../utils/api";
import { serviceError } from "../lib/serviceError";
import { getAccessToken, getCustomerID, getLeadID } from "../utils/storage";
import { getEnvironment } from "../utils/environment";
import { PAYMENT_GATEWAY } from "../Constants/constant";

const { API_URL, PRODUCT } = getEnvironment();

class EMIsAPI {
  // Payday EMI Loan List API
  async paydayEMILoanListAPI() {
    try {
      const req = {
        url: `loanapply/${PRODUCT}/payday_emi_loan_list_view`,
        method: "POST",
        data: {
          access_token: getAccessToken(),
          leadID: getLeadID(),
        },
      };

      const res = await apiData(req, "application/json", "php");
      return res;
    } catch (error) {
      serviceError(error);
    }
  }

  // Approval ROI View API
  async approvalROIViewAPI(values) {
    try {
      const req = {
        url: `loanapply/${PRODUCT}/v1/approval_roi_view`,
        method: "POST",
        data: {
          access_token: getAccessToken(),
          amount: values.AmountDetails.Amount,
          leadID: getLeadID(),
          productID: values.ProductID,
          step: "Repeat_Customer",
          tenure: values.TenureDetails.Tenure,
        },
      };

      const res = await apiData(req);
      return res;
    } catch (error) {
      serviceError(error);
    }
  }

  // Payday to EMI Conversion API
  async paydayToEMIConversionAPI(data) {
    try {
      const res = await axios({
        url: API_URL + "/crm/paydayToEmiConversion",
        method: "POST",
        data: {
          customer_id: getCustomerID(),
          firstDueDate: Number(localStorage.getItem("salaryDate")),
          lead_id: getLeadID(),
          loanAmtApproved: data.AmountDetails.Amount,
          productId: data.ProductID,
          roi: data.AmountDetails.ROI,
          tenure: data.TenureDetails.Tenure,
        },
        headers: {
          "Content-Type": "application/json",
          token: getAccessToken(),
        },
      });

      return res.data;
    } catch (error) {
      serviceError(error);
    }
  }

  // Repayment Data API
  async repaymentDataAPI() {
    try {
      const res = await axios({
        url: API_URL + "/customers/getRepaymentPageData",
        method: "POST",
        data: {
          leadId: getLeadID(),
          customer: {
            customerID: getCustomerID(),
          },
        },
        headers: {
          "Content-Type": "application/json",
          token: getAccessToken(),
        },
      });

      return res.data;
    } catch (error) {
      serviceError(error);
    }
  }

  // Create Order Payment API
  async createOrderPaymentAPI(amount) {
    try {
      const endpoint = "/customers/razorpay/create-order-repayment";
      const req = {
        amount: amount,
        leadId: Number(localStorage.getItem("leadID")),
      };

      const { data } = await api.post(endpoint, req);
      return data;
    } catch (error) {
      serviceError(error);
    }
  }

  // Rozarpay Order Status API
  async rozarpayOrderStatusAPI() {
    try {
      const endpoint = `/customers/fetchRazorpayOrder?leadID=${getLeadID()}`;
      const req = {};

      const { data } = await api.get(endpoint, req);
      return data;
    } catch (error) {
      serviceError(error);
    }
  }

  // Get Repayment Amount
  async getRepaymentAmountAPI() {
    try {
      const req = {
        url: `loanapply/${PRODUCT}/repayment`,
        method: "POST",
        data: {
          access_token: getAccessToken(),
          leadID: getLeadID(),
        },
      };

      const res = await apiData(req, "application/json", "php");
      return res;
    } catch (error) {
      serviceError(error);
    }
  }
  // Create Order Payment API
    async initiatePayment(amount) {
      try {
        const endpoint = "/payment/initiate-paymentV2";
        const req = {
          amount: Number(amount),
          leadID: Number(localStorage.getItem("leadID")),
        };
  
        const { data } = await api.post(endpoint, req);
        return data;
      } catch (error) {
        serviceError(error);
      }
    }

    async verifyPayment(paymentData, gateway){
      const endpoint = gateway === PAYMENT_GATEWAY.ROZAR_PAY ? '/payment/verify-razorpay-payment' : '/payment/verify-payment';
      try {
        const { data } = await api.post(endpoint, paymentData);
        return data;
      } catch (error) {
        serviceError(error);
      }
    };
}


export default EMIsAPI;
